
import CollapseTransition from "element-ui/lib/transitions/collapse-transition"
import programTime from "@/mixins/program-time"
import { MFM_PROGRAM_TZ_LABEL, mfmProgramNow } from "@/utils/date"
import { BROADCAST_LEAD_MS } from "@/utils/program"

interface Speaker {
  id?: string
  name: string
  role?: string
  photoUrl?: string
}

export default programTime.extend({
  components: { CollapseTransition },

  props: {
    id: { type: String, required: true },
    title: { type: String, default: "" },
    description: { type: String, default: "" },

    start: { type: Number, default: 0 },
    end: { type: Number, default: 0 },

    languages: { type: Array as VuePropType<string[]>, default: () => [] },
    language: { type: String, default: "" },
    broadcastUrl: { type: String, default: "" },
    blockTitle: { type: String, default: "" },
    speakers: { type: Array as VuePropType<Speaker[]>, default: () => [] },

    partnerLogo: { type: String, default: "" },
    partnerName: { type: String, default: "" },

    to: { type: String, default: "" },

    visibleSpeakersCount: { type: Number, default: 2 },
    expandableSpeakersCount: { type: Number, default: 5 },
  },

  data: () => ({
    isSpeakersExpanded: false,
  }),

  computed: {
    timezoneLabel (): string {
      return MFM_PROGRAM_TZ_LABEL
    },

    timeRange (): string {
      return this.programTimeRange(this.start, this.end)
    },

    broadcastState (): "upcoming" | "live" | "past" | "" {
      if (!this.start || !this.end) return ""

      const now = mfmProgramNow()

      if (now < this.start - BROADCAST_LEAD_MS) return "upcoming"
      if (now <= this.end) return "live"
      return "past"
    },

    isSpeakersExpandable (): boolean {
      return this.speakers.length <= this.expandableSpeakersCount
    },

    visibleSpeakers (): Speaker[] {
      return this.speakers.slice(0, this.visibleSpeakersCount)
    },

    extraSpeakers (): Speaker[] {
      return this.speakers.slice(this.visibleSpeakersCount)
    },

    hiddenSpeakersCount (): number {
      return this.extraSpeakers.length
    },
  },

  methods: {
    showMoreSpeakers () {
      if (this.isSpeakersExpandable)
        this.isSpeakersExpanded = true
      else
        this.$emit("details")
    },
  },
})
